import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const GoogleAdsRegister = lazyRouteComponent(() => import('../pages/ga-register'))

export const googleAdsRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/ga-register',
  component: GoogleAdsRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
